(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tedemogu-article-toc"] && !Shopify.designMode) return;
  try {
    function initializeTedemoguToc() {
    document.querySelectorAll('[data-tedemogu-toc-template]').forEach((template) => {
      const body = template.closest('[data-tedemogu-article-body]');
      if (!body || body.querySelector('#tedemogu-article-toc')) return;
      const headings = Array.from(body.querySelectorAll('h2')).filter((heading) =>
        heading.textContent.trim() && !heading.closest('aside, nav, details, [hidden]')
      );
      if (headings.length < 3) return;
      const toc = template.content.firstElementChild.cloneNode(true);
      const list = toc.querySelector('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) {
          const base = 'tedemogu-toc-section-' + (index + 1);
          let id = base;
          let suffix = 1;
          while (document.getElementById(id)) id = base + '-' + suffix++;
          heading.id = id;
        }
        heading.classList.add('tedemogu-toc-target');
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + encodeURIComponent(heading.id);
        link.textContent = heading.textContent.replace(/\s+/g, ' ').trim();
        item.append(link);
        list.append(item);
      });
      headings[0].before(toc);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTedemoguToc, { once: true });
  } else {
    initializeTedemoguToc();
  }
  document.addEventListener('shopify:section:load', initializeTedemoguToc);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tedemogu-cart-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tedemogu-cart-addon')) {
    customElements.define('tedemogu-cart-addon', class extends HTMLElement {
      connectedCallback() {
        this.onsubmit = (event) => {
          if (this.dataset.submitting === 'true') {
            event.preventDefault();
            return;
          }
          this.dataset.submitting = 'true';
          this.querySelector('button').disabled = true;
        };
      }
    });
    window.addEventListener('pageshow', () => {
      document.querySelectorAll('tedemogu-cart-addon').forEach((element) => {
        delete element.dataset.submitting;
        const button = element.querySelector('button');
        if (button) button.disabled = false;
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tedemogu-collection-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tedemogu-collection-filters')) {
    customElements.define('tedemogu-collection-filters', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const section = document.getElementById('shopify-section-' + this.dataset.sectionId);
        const grid = section?.querySelector('#product-grid');
        if (!grid) return;
        this.items = Array.from(grid.querySelectorAll('[data-tedemogu-age]'));
        if (!this.items.length) return;
        this.initialized = true;
        this.selection = { age: 'all', kind: 'all' };
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-reset')) {
            this.selection = { age: 'all', kind: 'all' };
            this.querySelector('[data-group="age"][data-value="all"]').focus();
          } else if (button.dataset.group) {
            this.selection[button.dataset.group] = button.dataset.value;
          }
          this.updateResults();
        });
        this.updateResults();
        this.hidden = false;
      }
      updateResults() {
        let count = 0;
        this.items.forEach((item) => {
          const matchesAge = this.selection.age === 'all' || item.dataset.tedemoguAge === this.selection.age;
          const matchesKind = this.selection.kind === 'all' || item.dataset.tedemoguKind === this.selection.kind;
          item.hidden = !(matchesAge && matchesKind);
          if (!item.hidden) count++;
        });
        this.querySelectorAll('[data-group]').forEach((button) => {
          button.setAttribute('aria-pressed', String(this.selection[button.dataset.group] === button.dataset.value));
        });
        this.querySelector('[data-count]').textContent = count;
        this.querySelector('[data-empty]').hidden = count !== 0;
        this.querySelector('[data-reset]').hidden = this.selection.age === 'all' && this.selection.kind === 'all';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tedemogu-coupon-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const hasCouponApi = () => typeof window.promolayer?.triggerDisplay === 'function';

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-tedemogu-coupon-trigger]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !hasCouponApi()) return;

      event.preventDefault();
      const menuToggle = document.querySelector('.hamburger[aria-expanded="true"]');
      if (menuToggle) menuToggle.click();

      try {
        window.promolayer.triggerDisplay(link.dataset.tedemoguCouponTrigger);
      } catch {
        window.location.assign(link.href);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
